import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import styles from "./index.module.css";

type Props = {
  mobile?: boolean;
  tablet?: boolean;
  desktop?: boolean;
  children?: ReactNode;
  className?: string;
};

const ShowOnMedia: FC<Props> = ({
  mobile = true,
  tablet = true,
  desktop = true,
  children,
  className,
}) => {
  return (
    <>
      <div
        className={classNames(styles.base, className, {
          [styles.mobile]: mobile,
          [styles.tablet]: tablet,
          [styles.desktop]: desktop,
        })}
      >
        {children}
      </div>
    </>
  );
};

export default ShowOnMedia;
